// Canonical detection-alert / rule severity values (lowercase), highest → lowest.
// Shared so rule drawers, ticket-priority mapping, etc. agree on the same set.
export const SEVERITY_OPTIONS = ['critical', 'high', 'medium', 'low', 'informational'];

// Title-case label for display (e.g. 'informational' → 'Informational').
export function severityLabel(sev) {
  const s = `${sev || ''}`;
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}
